export default "__VITE_ASSET__BodEt1KR__"